import { Icon, Typography } from '@/components/common';
import Icons from '@/const/icons';
import * as React from 'react';

export const Earned: React.FC<{ earned: number }> = ({ earned }) => {
	return (
		<div className="flex items-center gap-x-2 mt-4 lg:mt-0">
			<span className="w-6 h-6">
				<Icon src={Icons.moneyReceive} className="text-main-green w-6 h-6" />
			</span>
			<Typography type="bold-22" className="font-semibold">
				${earned?.toLocaleString()}
			</Typography>
		</div>
	);
};
